import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import UserService from "../controllers/UserService";
import AuthService from "../controllers/AuthService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import FriendshipGame from "../components/Game/FriendshipGame";
import $ from 'jquery';

class EvaluateStudentList extends React.Component {
    constructor(props) {
        super(props);
        this.changeData = this.changeData.bind(this);
        this.state = {
            user: AuthService.getCurrentUser(),
            role: AuthService.getUserRole(),
            modalShowEndActivity: false,
            // name: 'นายวัศพล คนไทย',
            id: '1234',
            // text1: 'ยังไม่ได้ประเมิน',
            // text2: 'ยังไม่ได้ประเมินคุณครู',
            // text3: 'ยังประเมินเพื่อนไม่ครบ (2/3)',
            status_text1: 'waiting',
            status_text2: 'done',
            status_text3: 'inprogress',
            students: [],
            currentStudentIdClick: null,
            roomId: props.roomId, //'60c0e14221965c37a7c1b75f'
            statusFriends: 0,
            statusTeacher: 0,
            statusSelf: 0,
            totalFriend: 0,
            // firstTeacherId: ''
            modalShow: false,
            roomyear: '',
            roomterm: '',
            roomgrade: '',
            roomgradeyear: ''

        };

    }


    componentDidMount() {
        UserService.getFriendshipReportList(this.state.roomId).then(
            (res) => {
                console.log('getFriendshipReportList');
                console.log(res);
                var allStudents = [];
                var count = 0;
                for (const [index, value] of res.data.data.entries()) {

                    if (value.user.roles[0].toLowerCase() !== 'teacher') {

                        var status = [];
                        var statusOverview = 0;
                        var statusFriends = 0; //-0 not yet, 1-inprogress, 2 done
                        var statusTeacher = 0;
                        var statusSelf = 0;
                        var teacherDone = 0;
                        var totalEntry = 0;

                        for (const [i, v] of value.targets.entries()) {
                            totalEntry++;
                            if (v.answerAt !== null) {

                                statusOverview++;
                                if (value.user.id === v.user.id) {
                                    statusSelf++;
                                }
                                else if (v.user.roles[0].toLowerCase() !== 'teacher') {
                                    statusFriends++;
                                    status.push(true);
                                } else if (v.user.roles[0].toLowerCase() === 'teacher') {
                                    statusTeacher++;
                                }

                            } else {
                                if (v.user.roles[0].toLowerCase() !== 'teacher' && value.user.id !== v.user.id) {
                                    status.push(false);
                                }
                            }

                        }

                        for (const [ii, vv] of value.others.entries()) {
                            if (vv.answerAt !== null && vv.user.roles[0].toLowerCase() === 'teacher') {
                                teacherDone++;
                            }
                        }

                        allStudents[count] = {
                            'name': value.user.fullName,
                            'id': value.user.id,
                            'status': status,
                            'statusOverview': statusOverview,
                            'statusFriends': statusFriends,
                            'statusTeacher': statusTeacher,
                            'statusSelf': statusSelf,
                            'teacherDone': teacherDone,
                            'classTeacherDone': teacherDone > 0 ? 't-done' : 't-notdone',
                            'totalFriend': totalEntry - 2,
                            'no': value.user.no,

                        }
                        // console.log(allStudents[count] );
                        count++;

                    }
                    // else {

                    //     if(value.user.roles[0].toLowerCase() === 'teacher') {                                    
                    //         this.setState({ firstTeacherId: (value.user.id)});                        
                    //     } 
                    // }           
                }

                allStudents.sort(function (a, b) { return a['no'] - b['no']; });
                console.log(allStudents);
                this.setState({ students: allStudents });
            });

        UserService.getRoomDetail(this.state.roomId).then((response) => {
            this.setState({ roomyear: response.data.data.year });
            this.setState({ roomterm: response.data.data.term });
            this.setState({ roomgrade: response.data.data.grade });
            this.setState({ roomgradeyear: response.data.data.gradeYear });
        });
    }

    changeData(id, name) {
        this.setState({ modalShowEndActivity: false });
        this.props.referenceCallback(id, name);
    }

    selectionChange() {
        var e = document.getElementById("selection-evaluate");
        var selectValue = e.value;
        var temp = $('#search').val();
        // var count1 = 1;
        if (!selectValue) {
            selectValue = 'all'
        }
        $('.div-detail').each(function (i, obj) {
            let studentName = obj.querySelector('.student-name').innerHTML + obj.querySelector('.student-no').innerHTML;
            let isDone = obj.classList.contains('t-done')
            var checkStatus = studentName.includes(temp);

            if (
                (checkStatus && selectValue === 'done' && isDone) ||
                (checkStatus && selectValue === 'notdone' && !isDone) ||
                (checkStatus && selectValue === 'all')
            ) {
                $(obj).show();
                // obj.querySelector('.order').innerHTML = count1;
                // count1++;
            } else {
                $(obj).hide();
            }
        });
    }


    render() {
        return (
            <div className="mb-5">
                <div className="px-4 main-detail">
                    <Row className="px-0" >

                        <Col xs={12} className="w-100 pb-3 px-0">
                            <Col className="w-100 px-0" id="search-div">
                                <FontAwesomeIcon icon={faSearch} className="gray-text3 icon-search"></FontAwesomeIcon>
                                <input className="form-control form-control-sm w-100 border-radius-5 search" type="text" id="search" placeholder="ค้นหา ชื่อ-นามสกุล หรือเลขที่" onInput={() => this.selectionChange()} />
                            </Col>
                        </Col>

                    </Row>
                    <Row>
                        <img src="/images/friendship-game/banner_friendship.jpg" className="click-pointer w-100 d-none d-lg-block" onClick={() => { this.setState({ modalShow: true }) }}></img>
                        <img src="/images/friendship-game/banner_friendship_mobile.jpg" className="click-pointer w-100 d-lg-none" onClick={() => { this.setState({ modalShow: true }) }}></img>
                    </Row>
                    <Row className="blue-bg py-2 mt-3">
                        <Col xs={2} md={2} className="text-center pr-0 gray-text3">เลขที่</Col>
                        <Col xs={6} md={2} className="text-center gray-text3">ชื่อ - นามสกุล</Col>
                        <Col xs={0} md={5} className="text-center gray-text3 d-none d-md-inline"></Col>
                        <Col xs={4} md={3} className="text-center px-0">
                            <select data-testid="selection-evaluate" id="selection-evaluate" className="selection-evaluate gray-text3" onChange={() => { this.selectionChange() }} style={{ "fontSize": "13px" }}>
                                <option value="" selected disabled hidden>สถานะของครู</option>
                                <option value="all">ทั้งหมด</option>
                                <option value="done">ประเมินแล้ว</option>
                                <option value="notdone">ยังไม่ประเมิน</option>
                            </select>
                        </Col>
                    </Row>
                    {
                        (this.state.students.length > 0) ? (
                            this.state.students.map((item, index) => (
                                <Row key={index.toString()} className={`border-bottom-blue py-3 div-detail ${item.classTeacherDone}`}>
                                    <Col xs={2} md={2} className="text-center my-1"><h5 data-testid="student-no" className="mb-0 font-weight-600 order student-no">{item.no}</h5></Col>
                                    <Col xs={7} md={7} className="text-left my-1">
                                        <Row>
                                            <Col xs={12} md={5} className="text-left my-1">
                                                <h5 data-testid="student-name" className="mb-0 font-weight-600 mb-1 student-name">{item.name}</h5>
                                                {item.statusOverview === 0 ? (<h6 data-testid="student-status-desc" className="gray-text15"> นักเรียนยังไม่ได้เริ่มประเมิน</h6>) : (<div></div>)}
                                                {item.statusOverview > 0 && item.statusOverview < 5 ? (<h6 data-testid="student-status-desc" className="gray-text15">นักเรียนประเมินยังไม่ครบ</h6>) : (<div></div>)}
                                                {item.statusOverview === 5 ? (<h6 data-testid="student-status-desc" className="gray-text15"> นักเรียนประเมินครบแล้ว</h6>) : (<div></div>)}
                                            </Col>
                                            <Col xs={12} md={7}>
                                                <Row>
                                                    <div className="pl-3 d-flex" data-testid="student-badge-evaluated">
                                                        {item.statusSelf ? (<img data-testid="badge-evaluated-to-self" src='/images/evaluate/school_1.png' className="d-inline school-image" />) : ('')}
                                                        {item.statusTeacher ? (<div className="position-relative"><div className={`number-done count-done-${item.statusTeacher}`}>{item.statusTeacher}</div><img data-testid="badge-evaluated-to-teacher" src='/images/evaluate/school_2.png' className="d-inline school-image" /></div>) : ('')}

                                                        <div className={`d-inline-flex`}>
                                                            {/* {item.status[0] ? ( <img data-testid="badge-evaluated-to-friend" src='/images/evaluate/school_3.png' className="d-inline school-image-f1" />) :('')}    
                                                            {item.status[1] ? ( <img data-testid="badge-evaluated-to-friend" src='/images/evaluate/school_4.png' className="d-inline school-image-f2" />) :('')}    
                                                            {item.status[2] ? ( <img data-testid="badge-evaluated-to-friend" src='/images/evaluate/school_5.png' className="d-inline school-image-f3" />) :('')}    */}

                                                            {item.statusFriends > 0 ? (<div className="position-relative"><div className={`number-done count-done-${item.statusFriends}`}>{item.statusFriends}</div><img data-testid="badge-evaluated-to-friend" src='/images/evaluate/school_3.png' className="d-inline school-image-f1" /></div>) : ('')}
                                                        </div>
                                                    </div>
                                                </Row>

                                                {/* <Row>
                                                    <Col xs="2" className="pr-0">
                                                        {item.status[1] ? ( <img src='/images/evaluate/school_1.png' className="d-inline school-image" />) :('')}   
                                                        
                                                    </Col> 
                                                    <Col xs="2" className="px-0">
                                                        {item.status[0] ? ( <img src='/images/evaluate/school_2.png' className="d-inline school-image" />) :('')}  
                                                    </Col> 
                                                    <Col xs="8" align="right" className={item.status[2] ? ('px-0') :('px-0 adjust-padding')}>
                                                        {item.status[2] ? ( <img src='/images/evaluate/school_3.png' className="d-inline school-image-f1" />) :('')}    
                                                        {item.status[3] ? ( <img src='/images/evaluate/school_4.png' className="d-inline school-image-f2" />) :('')}    
                                                        {item.status[4] ? ( <img src='/images/evaluate/school_5.png' className="d-inline school-image-f3" />) :('')}        
                                                    </Col> 
                                                </Row> */}
                                            </Col>
                                        </Row>

                                    </Col>

                                    <Col xs={3} md={3} className="text-right my-1 d-flex">
                                        {/* { (this.state.user.id ===  this.state.firstTeacherId) ? (  */}
                                        {(1) ? (
                                            item.teacherDone !== 0 ? <img data-testid="teacher-status" data-value="done" src='/images/evaluate/check.png' className="evaluate-status m-auto click-pointer" onClick={() => { this.setState({ totalFriend: item.totalFriend }); this.setState({ modalShowEndActivity: true }); this.setState({ currentStudentIdClick: item.id }); this.setState({ statusFriends: item.statusFriends }); this.setState({ statusTeacher: item.statusTeacher }); this.setState({ statusSelf: item.statusSelf }); this.setState({ currentStudentNameClick: item.name }); }} /> : <img data-testid="teacher-status" data-value="pending" src='/images/evaluate/wait_teacher.png' className="evaluate-status m-auto click-pointer" onClick={() => { this.setState({ modalShowEndActivity: true }); this.setState({ currentStudentIdClick: item.id }); this.setState({ statusFriends: item.statusFriends }); this.setState({ statusTeacher: item.statusTeacher }); this.setState({ statusSelf: item.statusSelf }); this.setState({ totalFriend: item.totalFriend }); this.setState({ currentStudentNameClick: item.name }); }} />
                                        ) : (
                                            item.teacherDone !== 0 ? <img data-testid="teacher-status" data-value="done" src='/images/evaluate/check.png' className="evaluate-status m-auto click-pointer" /> : <img data-testid="teacher-status" data-value="pending" src='/images/evaluate/wait_teacher.png' className="evaluate-status m-auto click-pointer" />
                                        )
                                        }
                                    </Col>
                                </Row>
                            ))
                        ) : (
                            <div></div>
                        )
                    }
                </div>
                <div>
                    <Modal
                        show={this.state.modalShowEndActivity}
                        onHide={() => { this.setState({ modalShowEndActivity: false }) }}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        className="alert-modal"
                    >
                        <Modal.Body className="font-sarabun text-center pt-1">
                            <p className="text-right m-0"><img src='/images/evaluate/x.png' className="click-pointer" onClick={() => { this.setState({ modalShowEndActivity: false }) }} /></p>
                            <p className="primary-text font-sarabun-bold" data-testid="selected-student-name"><img src='/images/evaluate/book3.png' /> {this.state.currentStudentNameClick}</p>
                            <Row className="evaluate-modal">
                                <Col className="pr-md-0">
                                    <img src='/images/evaluate/school_1.png' className="modal-school-image" />
                                    <h5 className="font-sarabun-bold mt-4"><span style={{ "color": '#4F4F4F' }}>ตัวเอง</span></h5>
                                    {this.state.statusSelf === 0 ? (<div><h6 className="text-blue-evaluate" data-testid="selected-student-self-status">ยังไม่ได้ทำประเมิน</h6></div>) : (<div><h6 className="text-green-evaluate" data-testid="selected-student-self-status">ทำประเมินแล้ว</h6></div>)}

                                </Col>
                                <Col className="px-md-0" style={{ "borderRight": '1px solid #E0E0E0', "borderLeft": '1px solid #E0E0E0' }}>
                                    <div className="position-relative m-auto" style={{ "width": "fit-content" }}>
                                        <div className={`number-done count-done-${this.state.statusTeacher}`}>{this.state.statusTeacher}</div>
                                        <img src='/images/evaluate/school_2.png' className="modal-school-image" />
                                    </div>
                                    <h5 className="font-sarabun-bold mt-4"><span style={{ "color": '#4F4F4F' }}>คุณครู</span></h5>
                                    {this.state.statusTeacher === 0 ? (<div> <h6 className="text-blue-evaluate" data-testid="selected-student-teacher-status">ยังไม่ได้ทำประเมิน</h6></div>) : (<div><h6 className="text-green-evaluate" data-testid="selected-student-teacher-status">ทำประเมินแล้ว</h6></div>)}
                                </Col>
                                <Col className="pl-md-0">
                                    <div className="position-relative m-auto" style={{ "width": "fit-content" }}>
                                        <div className={`number-done count-done-${this.state.statusFriends}`}>{this.state.statusFriends}</div>
                                        <img src='/images/evaluate/school_3.png' className="modal-school-image" />
                                    </div>
                                    {/* <img src='/images/evaluate/school_4.png' className="modal-school-image div-50 evaluate-modal-image2" />
                                    <img src='/images/evaluate/school_5.png' className="modal-school-image div-50 evaluate-modal-image3" /> */}
                                    <h5 className="font-sarabun-bold mt-4"><span style={{ "color": '#4F4F4F' }}>เพื่อน</span></h5>
                                    {this.state.statusFriends === 0 ? (<div><h6 className="text-blue-evaluate">ยังไม่ได้ทำประเมิน</h6></div>) : ('')}
                                    {this.state.statusFriends < this.state.totalFriend && this.state.statusFriends > 0 ? (<div><h6 className="text-yellow-evaluate" data-testid="selected-student-friend-status">ยังประเมินเพื่อนไม่ครบ ({this.state.statusFriends}/{this.state.totalFriend})</h6></div>) : ('')}
                                    {this.state.statusFriends === this.state.totalFriend && this.state.statusFriends !== 0 ? (<div><h6 className="text-green-evaluate" data-testid="selected-student-friend-status">ทำประเมินครบแล้ว</h6></div>) : ('')}

                                </Col>
                            </Row>
                            <Button data-testid="start-evaluated-button" className="bluebtn d-inline py-1 py-md-2 px-3 mt-3 font-sarabun-bold border-radius-10" onClick={() => { this.changeData(this.state.currentStudentIdClick, this.state.currentStudentNameClick) }}>เริ่มประเมิน</Button>
                        </Modal.Body>
                    </Modal>


                    <Modal
                        show={this.state.modalShow}
                        onHide={() => { this.setState({ modalShow: false }) }}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        className="alert-modal"
                    >
                        <Modal.Body className="font-sarabun text-center pt-1">
                            <p className="text-right m-0"><img src='/images/evaluate/x.png' className="click-pointer" onClick={() => { this.setState({ modalShow: false }) }} /></p>
                            <Row className="evaluate-modal-friendship">
                                {(this.state.roomyear && this.state.roomterm && this.state.roomgrade && this.state.roomgradeyear) ? <FriendshipGame year={this.state.roomyear} term={this.state.roomterm} grade={this.state.roomgrade} gradeYear={this.state.roomgradeyear} showFilterGradeYear={false} showHeader={false} /> : null}
                            </Row>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default EvaluateStudentList
